import { useContext } from "react";
import { CsAttributeContext } from "../context/CsAttributeContext";
/**
 * Use attribute from the server state
 * - requires {@linkcode CsAttributeController}
 *
 * @category Hook
 * @category CsAttribute
 * @export
 * @template TAttribute
 * @returns {TAttribute}
 */
export function useCsAttribute() {
    const attribute = useContext(CsAttributeContext);
    return attribute;
}
//# sourceMappingURL=useCsAttribute.js.map